<template>
  <div class="position-sticky" style="top: 80px; z-index: 1">
    <InventoryNavButtons />
  </div>
</template>

<script setup></script>

<style scoped>
.v-list-group__items .v-list-item {
  padding-left: 20px !important;
}
</style>
